import * as types from './mutation-types';
import * as actions from './actions';

const state = {
	message: 'Initial message from module',
};

const getters = {
	getMessage: state => state.message
}

const mutations = {
	[types.SET_MESSAGE](state, newMessage) {
		state.message = newMessage;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};